module.exports = __webpack_public_path__ + "static/media/chicken9.6ccbb31e.jpg";